const UnlinkIdentityProviderErrors = [
    { code: '0001', message: 'Hubo un error, porfavor vuelva a intentarlo' },
    { code: '0002', message: 'Hubo un error, porfavor vuelva a intentarlo' },
    { code: '0003', message: 'El perfil seleccionado no puede desvincularse de esta cuenta' },
    { code: '0004', message: 'El perfil seleccionado no puede desvincularse de esta cuenta' },
    { code: '0005', message: 'No es posible desvincular el perfil primario de la cuenta.' },
    { code: 'DEFAULT', message: 'Hubo un error, porfavor vuelva a intentarlo'}
];

export default UnlinkIdentityProviderErrors;